export default __webpack_public_path__ + "static/media/chicago.5940dde4.jpg";